import React from 'react';
import { Box, Link, styled, Text } from 'bumbag';
import format from 'date-fns/format';
import _get from 'lodash/get';
import { Link as RouterLink } from 'react-router-dom';

const LinkWrapper = styled(Box)`
  height: 44px;
`;
const OutOfPocketWrapper = styled(Box)`
  border-bottom: 0.5px solid #d3d3d3;
  border-top: 0.5px solid #d3d3d3;
  padding-top: 10px;
  padding-bottom: 10px;
  margin-top: 10px;
  margin-bottom: 20px;
`;
const TotalsRow = styled(Box)`
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
  margin-bottom: 5px;
`;
type Props = {
  originalPayment: Record<string, any>;
  refund: Record<string, any>;
  transactionId: string;
};

const RefundTotals = ({ originalPayment, refund, transactionId }: Props) => {
  const items = [
    ..._get(refund, 'refund.claimItems', []),
    // @ts-expect-error TS(7006): Parameter 'item' implicitly has an 'any' type.
    ..._get(refund, 'refund.otherItems', []).map(item => ({ ...item, isNonClaimable: true })),
  ];
  return (
    <Box>
      <h2>Refund details</h2>
      <LinkWrapper>
        <Link
          // @ts-expect-error
          use={RouterLink}
          to={`/account/transactions/view/?id=${transactionId}&paymentId=${originalPayment.paymentId}`}
          tabIndex={0}
        >
          Original transaction
        </Link>{' '}
        from {format(originalPayment.paymentDateString, 'DD/MM/YYYY')}
      </LinkWrapper>
      {items.map(item => (
        <TotalsRow key={item.itemId}>
          <Text>{item.isNonClaimable ? item.description : `${item.itemCode} - ${item.displayName}`}</Text>
          <Text>-{item.amountRefundString}</Text>
        </TotalsRow>
      ))}
      <OutOfPocketWrapper>
        <TotalsRow>
          <Text fontWeight="bold">TOTAL REFUND</Text>
          <Text fontWeight="bold">-{refund.amountString}</Text>
        </TotalsRow>
      </OutOfPocketWrapper>
    </Box>
  );
};

RefundTotals.defaultProps = {};
export default RefundTotals;
